<div class="dialog-title-row">
  <h1 mat-dialog-title>{{ data?.title }}</h1>
  <button
    *ngIf="data?.showCloseIcon"
    mat-icon-button
    class="dialog-close-button"
    aria-label="Close"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <p [innerHtml]="data.body"></p>
  <ng-container *ngIf="data.showCheckbox">
    <mat-checkbox [(ngModel)]="isChecked">{{ data.checkboxMessage }}</mat-checkbox>
  </ng-container>
  <ul *ngIf="data?.manufacturer && data?.sku">
    <li>{{ data?.manufacturer }} - {{ data?.sku }}</li>
  </ul>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close *ngIf="!data?.hideCancelBtn">
    {{ data?.cancelButton ? data?.cancelButton : 'No' }}
  </button>
  <button mat-raised-button color="primary" (click)="confirm()">
    {{ data?.confirmButton ? data?.confirmButton : 'Yes' }}
  </button>
</div>
